import React, { Component } from 'react';
import styled from 'styled-components';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export const LinkText = styled.span`
  color: #677387;
  text-decoration: underline;
  font-size: 22px;
  font-family: 'Poor Story';
  &:hover {
    color: blue;
  }
  &:active {
    color: purple;
  }
  &:focus {
    box-shadow: 1px 1px 1px #4d598a;
  }
`;

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container>
            <NavbarBrand tag={Link} to="/">
              <table><tbody><tr>
                <td><img width="50px" height="50px" src="images/pray.png" alt="" /></td>
                <td width="15px" />
                <td><h1>구국 금식 기도 운동</h1></td>
              </tr></tbody></table>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/"><LinkText>홈 페이지</LinkText></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/about"><LinkText>취지</LinkText></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/chart"><LinkText>참가자</LinkText></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/signup"><LinkText>금식 기도 참여</LinkText></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/prayers"><LinkText>기도문</LinkText></NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
